module.exports = __webpack_public_path__ + "static/media/ams.81d2d58a.png";